import React from 'react';
interface ButtonProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  children: React.ReactNode;
  className?: string;
}
export function Button({
  children,
  className = '',
  ...props
}: ButtonProps) {
  return <a className={`inline-flex items-center justify-center px-8 py-4 text-base md:text-lg font-bold text-carbon bg-gold hover:bg-[#d9a404] transition-colors duration-200 rounded-sm text-center ${className}`} target="_blank" rel="noopener noreferrer" {...props} data-id="element-49">
      {children}
    </a>;
}